<template>
  <Card
    dis-hover
    shadow
  >
    <modal-acount-fix ref="acountFix"></modal-acount-fix>
    <modal-site-settings ref="siteSetting"></modal-site-settings>
    <modal-site-log ref="ModalSiteLog"></modal-site-log>
    <game-gearing ref="gameGearing"></game-gearing>
    <div slot="title">
      <Button
        type="warning"
        :to="{ name: 'add-acount' }"
        class="mr-3"
        v-if="getpermission.member[1] == '1'"
      >
        <b>新增站点</b>
      </Button>
      <Button
        type="info"
        :to="{ name: 'maintain-record' }"
      >
        <b>网站维护</b>
      </Button>
    </div>
    <h2 class="text-center">站点列表</h2>
    <p>
      <span class="mr-1">站点状态</span>
      <Select v-model="siteState" style="width: 100px;" @on-change="GetAcountListTable">
        <Option v-for="item in siteStateList" :value="item.state" :key="item.id">{{ item.stateName }}</Option>
      </Select>
    </p>
    <lida-table
      :propscolumns="column"
      :data="acountdata"
      :sortStatus="false"
    ></lida-table>
  </Card>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import siteGroup from 'utils/site-group.js'
export default {
  name: 'list',
  components: {
    'ModalSiteLog': () => import(/* webpackChunkName: "ModalSiteLog" */ './components/ModalSiteLog.vue'),
    'ModalAcountFix': () => import(/* webpackChunkName: "ModalAcountFix" */ './components/ModalAcountFix.vue'),
    'ModalSiteSettings': () => import(/* webpackChunkName: "ModalSiteSettings" */ './components/ModalSiteSettings.vue'),
    'GameGearing': () => import(/* webpackChunkName: "GameGearing" */ './components/GameGearing.vue')
  },
  provide () {
    return {
      GetAcountListTable: this.GetAcountListTable,
    }
  },
  data () {
    return {
      acountdata: [],
      acountFixModel: false,
      managementModel: false,
      siteState: 1,
      siteStateList: [
        { stateName: '全部', state: 2, id: 2 },
        { stateName: '啟用', state: 1, id: 1 },
        { stateName: '停用', state: 0, id: 0 }
      ]
    };
  },
  created () {
    this.GetAcountListTable()
  },
  watch: {
    pageSize (val) {
      this.handleListApproveHistory()
    }
  },
  computed: {
    ...mapGetters(["getacounts", "getmember", "getpermission", "getgameid"]),
    memnameShow () {
      return this.getpermission.member[2] == '0' && this.getpermission.member[3] == '0'
    },
    column () {
      return {
        username: {
          title: '站点帐号/名称',
          key: 'username',
          align: 'center',
          className: "infor-column",
          render: (h, params) => h('span', `${params.row.username}[ ${params.row.memname} ]`)
        },
        siteClass: {
          title: '站别类型',
          key: 'siteClass',
          align: 'center',
          render: (h, params) => h('span', siteGroup.items[params.row.siteClass])
        },
        crdate: {
          title: '新增日期',
          key: 'crdate',
          align: 'center',
        },
        state: {
          title: '状态',
          key: 'state',
          align: 'center',
          render: (h, params) => {
            const color = params.row.state == 1 ? 'green' : 'red'
            return h('Tag', {
              props: {
                color: color
              }
            }, this.TextState(params.row.state))
          }
        },
        memname: {
          title: '操作',
          key: 'memname',
          align: 'center',
          width: 420,
          hide: this.memnameShow,
          render: (h, params) => {
            const ButtonState = {
              class: {
                'mr-1': true
              },
              props: {
                type: "info"
              }
            }
            const ChangeStateClick = {
              click: () => this.aco(params.row.id, params.row.state == '1' ? '0' : '1')
            }
            const ModifyonClick = {
              click: () => this.$refs.acountFix.GetAcountFixData(params.row.id)
            }
            const siteSetting = {
              click: () => this.$refs.siteSetting.getSiteSettings(params.row.id)
            }
            const gameGearingClick = {
              click: () => this.$refs.gameGearing.getlist(this.getgameid, params.row.id)
            }
            const GameClick = {
              click: () => this.$router.push({ name: 'game-management', query: { siteid: params.row.id, siteClass: params.row.siteClass } })
            }
            const logClick = {
              click: () => this.$refs.ModalSiteLog.modelDate(params.row.id)
            }
            return h('div', [
              this.getpermission.member[2] == '1' ? h('Button', { ...ButtonState, on: ChangeStateClick }, this.BtnTextState(params.row.state)) : '',
              this.getpermission.member[2] == '1' ? h('Button', { ...ButtonState, on: ModifyonClick }, '修改') : '',
              this.getpermission.member[2] == '1' ? h('Button', { ...ButtonState, on: siteSetting }, '站点设置') : '',
              this.getpermission.member[2] == '1' ? h('Button', { ...ButtonState, on: GameClick }, '遊戲管理') : '',
              this.getpermission.member[3] == '1' ? h('Button', { ...ButtonState, on: logClick }, '日誌/維護') : ''
            ])
          }
        }
      }
    }
  },
  methods: {
    ...mapActions(["chg_acounts"]),
    TextState (state) {
      let text
      switch (state) {
        case 0:
          text = '停用'
          break;
        case 1:
          text = '啟用'
          break;
        case 3:
          text = '停押'
          break;
      }
      return text
    },
    BtnTextState (state) {
      let text
      switch (state) {
        case 1:
          text = '停用'
          break;
        case 0:
          text = '啟用'
          break;
      }
      return text
    },
    async GetAcountListTable () {
      try {
        const res = await this.$axios.acount.tb(this.siteState)
        if ('status' in res && res.status === 0) return
        this.acountdata = res
      } catch (error) {
        console.error(error)
      }
    },
    aco (id, actio) {
      this.$Modal.confirm({
        title: "提示信息",
        content: "确认是否要更改 ?",
        onOk: res => {
          const obj = {
            mid: id,
            loid: this.getmember.pid,
            actio: actio
          }
          this.$axios.acount
            .stop_memdebr(obj)
            .then(res => {
              if (res.status == '1') {
                this.GetAcountListTable()
              }
            });
        }
      });
    },
    record (id) {
      this.chg_acounts({ recordid: id });
      this.chg_acounts({ record_mod: true });
    }
  }
};
</script>